
import { Vue } from 'vue-property-decorator'
import { AuthenticationService } from '@/store'
import { RouterUtils } from '@/commons/utils/router'

export default class ModalBoxTimeoutWarning extends Vue {
    async logoutHandler (): Promise<void> {
        await AuthenticationService.logout()
        await this.$router.push(this.$route.path !== '/login' ? '/login' : '/', RouterUtils.setFocusToBody)
    }

    async refreshSessionHandler (): Promise<void> {
        await AuthenticationService.refreshSession()
    }
}
